export default __webpack_public_path__ + "static/media/outside.3adb0c4c.png";